<template><section><h1>Price</h1>
<blockquote>
<p>价格</p>
</blockquote>
<h2>代码示例</h2>
<p><test></test></p>

<h2>API</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>color</td>
<td style="text-align:left">颜色</td>
<td><code>String</code></td>
<td><code>#f02f45</code></td>
</tr>
<tr>
<td>font_size</td>
<td style="text-align:left">字号大小</td>
<td><code>Number</code></td>
<td><code>24</code></td>
</tr>
<tr>
<td>super</td>
<td style="text-align:left">价格符号是否对其文本的上标</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
<tr>
<td>delete</td>
<td style="text-align:left">是否为<code>Del</code>样式</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
<tr>
<td>suffix</td>
<td style="text-align:left">后缀文本</td>
<td><code>String/Number</code></td>
<td>-</td>
</tr>
<tr>
<td>text_size</td>
<td style="text-align:left">文本和符号大小</td>
<td><code>Number</code></td>
<td>-</td>
</tr>
<tr>
<td>no_shrink</td>
<td style="text-align:left">文本和符号价格符号不缩小</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
<tr>
<td>symbol</td>
<td style="text-align:left">价格符号</td>
<td><code>String</code></td>
<td><code>￥</code></td>
</tr>
</tbody>
</table>
</section></template>

<script>
  import test from '@/pages/demo/Price.vue';

  export default {
    components: {
      test
    }
  }
</script>


// WEBPACK FOOTER //
// index-9.vue?37707776